module.exports = __webpack_public_path__ + "static/media/miwa_deleat_icon.340cf96a.svg";